{
  "internal_id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true,
    },
  },
  "notice_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Date",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "contract_no": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Parcel No.",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "area_ha": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Area",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "zone_description_list": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Zones",
      "width": 200,
      "isShownByDefault": true,
    },
  },
  "segments": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "# of Segments",
      "width": 50,
    },
  },
  "contract_type": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["Lease", "License"],
    },
    "ui": {
      "label": "Contract Type",
      "isShownByDefault": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "region_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Region",
      "isShownByDefault": true,
    },
  },
  "restriction_code_list": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Restrictions",
      "isNotRenderable": true,
    },
  },
  "lands_json": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true,
    },
  },
  "is_area_partial_lsd_or_portion": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is Partial",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "has_amendment": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Has Amendment",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "rights_type": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Type",
      "width": 125,
      "isShownByDefault": true,
    },
  },
}
